import './_hcp-header-nav.scss';
import {useContext, useEffect, useMemo, useRef, useState} from "react";
import { Link, useLocation,  } from "react-router-dom";
import { LayoutContext } from "../../../../components/layout-context-container";
import {hcpHeaderNavigationItems, hcpSitemapNavigationItems} from "../../../../router/hcpPageData";
import {navArray} from "../../../../router/navArray";
import {getScrollbarWidth} from "../../../../util/getScrollbarWidth";
import PatientButtonInterstitial from "../../../../components/button-interstitial";

import mobileMenu from './images/icon-header-mobile-menu.svg';
import {renderToString} from "react-dom/server";


function HcpHeaderNav({
  mobile = false,
  customClass = "",
  ...rest
}) {
  const { showMobileMenu, setShowMobileMenu, setHcpSubnavState, stickyHeaderFixedState } = useContext(LayoutContext);
  const [ currentNavGroupId, setCurrentNavGroupId ] = useState(0);
  const Location = useLocation();

  const currentPath = useMemo(() => {
    return Location.pathname;
  }, [Location]);
  
  const containerClass = useMemo(() => {
    let className = 'hcp-header-nav';

    if (showMobileMenu) {
      className = `${className} hcp-header-nav--menu-show`;
    }
    if (mobile) {
      className = `${className} hcp-header-nav--mobile`;
    }
    if (customClass) {
      className = `${className} ${customClass}`;
    }

    return className;
  }, [showMobileMenu, mobile, customClass]);

  const navigationItems = useMemo(() => {
    let navItemsFromRouter = undefined;
    if(mobile){
      navItemsFromRouter = Object.values(hcpSitemapNavigationItems);
      navItemsFromRouter.pop();
    }else{
      navItemsFromRouter = Object.values(hcpHeaderNavigationItems);
    }

    return navArray({
      navItemsFromRouter
    });
  }, [mobile]);

  /////// calculate scrollbar width to set component width //////
  const containerRef = useRef(null);
  useEffect(() => {

    containerRef.current?.style.setProperty('--subnav-width', `calc(100vw - ${getScrollbarWidth()}px)`);
  }, [containerRef]);

  function setPageSubnavGroup() {
    const filter = navigationItems.filter((page) => currentPath.startsWith(page.path) && page.path !== "/hcp");
    if (filter.length) {
      setCurrentNavGroupId(parseInt(filter[0].groupId));
    }
  }

  /////// set currentNavGroupId to the current page when the current path changes \\\\\\\\
  useEffect(() => {
    if(currentPath !== "/hcp"){
      setPageSubnavGroup();
    }else{
      setCurrentNavGroupId(0);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPath, navigationItems]);

  // reset subnav when the sticky nav is set to fixed
  useEffect(() => {
    if (stickyHeaderFixedState) {
      if(currentPath !== "/hcp"){
        setPageSubnavGroup();
      }else{
        setCurrentNavGroupId(0);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stickyHeaderFixedState]);

  /////// move main content down as the sub nav hides and shows \\\\\\\\
  useEffect(() => {
    if(!mobile){
      const subNavRef = containerRef.current?.querySelector(`.hcp-header .show-subnav .hcp-header-nav__item-subnav[data-group="${currentNavGroupId}"]`);
      const stickyHeaderRef = document.querySelector(".sticky-header");

      /////// add subnav padding if subnav is open //////
      // !!! this class is also applied in sticky-header/index.js
      if (subNavRef !== null) {
        stickyHeaderRef.classList.add("subnav-spacing");
        setHcpSubnavState(true);
      } else {
        stickyHeaderRef.classList.remove("subnav-spacing");
        setHcpSubnavState(false);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentNavGroupId, showMobileMenu]);

  /////// Click handlers \\\\\\\\
  function handleShowHidMobileMenu(e) {
      setShowMobileMenu(!showMobileMenu);
  }

  function handleNavClick(e) {
    const group = e.currentTarget.dataset?.group;

    if(parseInt(group) === currentNavGroupId){
      setCurrentNavGroupId(0);
    }else{
      setCurrentNavGroupId(parseInt(group));
    }

    const hasDropdown = e.currentTarget.classList.contains('has-dropdown');
    !hasDropdown && mobile && setShowMobileMenu(!showMobileMenu);

  }

  /////// set nav class to show current page or to show-subnav \\\\\\\\
  const getNavStateClasses = (page) => {
    let className =
      (page.path === '/hcp' && currentPath === '/hcp') ||
      (page.path !== '/hcp' && currentPath.startsWith(page.path) && (page.path.split("/").length -1) < 3) ||
      (page.path.replace(/\/$/, "") === currentPath.replace(/\/$/, ""))
        ? ` current`
        : '';
    if (currentNavGroupId !== undefined && page.subPages) {
      className = `${className}${currentNavGroupId === page.groupId ? ' show-subnav' : ''}`
    }
    return className;
  }

  return (
    <nav className={containerClass} {...rest}  ref={containerRef} aria-label='Primary Navigation'>
      <div className="hcp-header-nav__items" role="menubar">
        {navigationItems.map((page, i) => (
          <div className={`hcp-header-nav__item${getNavStateClasses(page)}`}
            key={`key_header_nav_item_container_${i}`}
          >
              <Link
                className={page.subPages ? "has-dropdown" : ""}
                key={`key_header_nav_item_${i}`}
                to={page.subPages ? undefined : page.path}
                onClick={handleNavClick}
                data-group={page.groupId}
                data-gtm-event-name="Header"
                data-gtm-event-category="Navigation"
                data-gtm-event-action="Click"
                data-gtm-event-label={page.path === '/hcp' ? "HOME" : renderToString(page.name).replace(/<[^>]*>/g, '')}
                draggable="false"
                role="menuitem"
                aria-haspopup="true"
                aria-expanded={currentNavGroupId === page.groupId}
              ><span>{page.name}</span></Link>

            {page.subPages
                ? <div
                  className = "hcp-header-nav__item-subnav"
                  data-group={page.groupId}
                  aria-label="Subnavigation"
                  role="menu"
                  aria-hidden={currentNavGroupId !== page.groupId}
                >
                  {page.subPages.map((subpage, x) => (

                      <Link
                        className={getNavStateClasses(subpage)}
                        key={`key_header_sub_nav_item_${x}`}
                        to={subpage.path}
                        onClick={handleNavClick}
                        data-gtm-event-name="Header"
                        data-gtm-event-category="Navigation"
                        data-gtm-event-action="Click"
                        data-gtm-event-label={ renderToString(subpage.name).replace(/<[^>]*>/g, '')}
                        draggable="false"
                        role="menuitem"
                      >{subpage.name}</Link>
                  ))}
                </div>
                : ''}
          </div>
          ))}
      </div>

      {!mobile && <div className="hcp-header-nav__button-mobile-menu">
        <button type="button" onClick={handleShowHidMobileMenu}>
          <img loading="lazy" src={mobileMenu} alt="Open menu" width={45} height={66}/>
        </button>
      </div>}
      {mobile && <Link
        to="/hcp/keep-in-touch"
        onClick={handleNavClick}
        className={currentPath.includes('keep-in-touch')
          ? 'hcp-header-nav__keep-in-touch current'
          : 'hcp-header-nav__keep-in-touch'}
        data-gtm-event-name="Header"
        data-gtm-event-category="Navigation"
        data-gtm-event-action="Click"
        data-gtm-event-label="Keep in Touch"
        draggable="false"
      >Keep In Touch</Link>}

      {mobile && <div className="hcp-header-nav__patient-link">
        <PatientButtonInterstitial
          variant="anchorlink"
          type=""
          buttonUrl="/"
          data-gtm-event-name="Header"
          data-gtm-event-category="Navigation"
          data-gtm-event-action="Click"
          data-gtm-event-label="Patient Site"
        >
          <span>Patient site</span>
        </PatientButtonInterstitial>
      </div>}

    </nav>
  );
}

export default HcpHeaderNav;